export const CREATION_SCENE_DURATION = 700;
export const NODE_BURST_DURATION = 400;
export const CONVERSATION_REVEAL_DELAY = 260;
export const SCENE_RESET_DELAY = 430;

export function resolveSceneWheelAction({ page, deltaY, scrollTop = 0 }) {
  if (Math.abs(deltaY) < 24) return null;
  if (page === "home" && scrollTop <= 2 && deltaY < 0) return "enter-creation";
  if (page === "creation" && deltaY > 0) return "return-home";
  return null;
}
